import React from 'react';
import { Text } from '../../components/base/Text';
import { DeleteFilled } from '@ant-design/icons';
import { Select } from 'antd';
import { TextArea, TextInput } from '../../components/base';
const { Option } = Select;
/**
 * A Relyant flow step starts with an event item, and it is followed by actions.
 * There is a set of predefined events that are supported by the application,
 * and the action can be more freely defined by the users.
 *
 * @returns
 */
export const FlowStep = ({ predefinedSteps, step, isEditing, setStep, deleteStep, }) => {
    const getLabel = ({ stepType }) => {
        const mapping = {
            event: 'Event: ',
            agent: 'Agent: ',
            action: 'Action: ',
        };
        return mapping[stepType] || mapping['action'];
    };
    const getPredefinedStep = (stepSlug) => {
        for (let step of predefinedSteps) {
            if (step.slug === stepSlug)
                return step;
        }
        return undefined;
    };
    const setStepPrompt = (text) => {
        step.user_prompt = text;
        setStep(step);
    };
    const gapSteps = 12;
    return (React.createElement("div", { id: "flow-step", style: { gap: gapSteps, justifyContent: 'flex-start', width: '100%' } },
        React.createElement("div", { className: "flex-row", style: { gap: gapSteps } },
            React.createElement(React.Fragment, null,
                React.createElement(Text, { value: getLabel({ stepType: step.type }), style: { fontWeight: 700, color: 'black', minWidth: '20%' } }),
                React.createElement(Select, { onSelect: (option) => {
                        const newStep = predefinedSteps.filter((predefinedStep) => predefinedStep.id === option);
                        setStep(newStep[0]);
                    }, defaultValue: step.text, disabled: !isEditing, value: step.text || undefined, showSearch: true, style: { width: '100%' }, placeholder: "Select an option", optionFilterProp: "label", optionLabelProp: "label", filterOption: (input, option) => {
                        return option?.label.toString().toLowerCase().includes(input.toLowerCase());
                    } }, predefinedSteps
                    .filter((predefinedStep) => predefinedStep.type === step.type)
                    .map((option) => {
                    return (React.createElement(Option, { key: option.id, value: option.id, label: option.text },
                        React.createElement("div", { style: {} },
                            React.createElement("div", { className: "flex-row", style: { alignItems: 'center', gap: '8px' } },
                                option.icon_url ? React.createElement("img", { src: option.icon_url, alt: "" }) : null,
                                option.text),
                            React.createElement("div", { style: { fontSize: 'small', color: 'grey' } }, option.ui_description))));
                })),
                isEditing ? React.createElement(DeleteFilled, { style: { color: 'red' }, onClick: deleteStep }) : null)),
        step.type === 'event' && getPredefinedStep(step.slug)?.params ? (React.createElement("div", { style: { marginTop: gapSteps, marginBottom: 3 * gapSteps } }, Object.keys(getPredefinedStep(step.slug).params).map((paramKey) => {
            return (React.createElement("div", { className: "flex-column", key: `${step.id}-${paramKey}`, style: { width: '100%' } },
                React.createElement("div", { className: "flex-row" },
                    React.createElement(Text, { value: `${paramKey}: `, style: { fontWeight: 500, color: 'black', minWidth: '20%' } }),
                    React.createElement(TextInput, { disabled: !isEditing, value: (step.params && step.params[paramKey]) || '', setText: (text) => {
                            step.params = {
                                ...step.params,
                                [paramKey]: text,
                            };
                            setStep(step);
                        }, maxLines: 1, style: { width: '50%' } }))));
        }))) : null,
        step.type === 'agent' ? (React.createElement("div", { style: { display: 'flex', marginTop: gapSteps, marginBottom: gapSteps } },
            React.createElement(TextArea, { isDisabled: !isEditing, placeholder: step.placeholder || '', text: step.user_prompt || '', setText: setStepPrompt, minLines: 2, maxLines: 10, style: { minHeight: 120, maxHeight: 480 } }))) : null));
};
